import { useMemo } from "react";

const useUserStatus = (record) =>
  useMemo(() => {
    const status = record?.status;
    const validationStatus = record?.validation_status;
    if (validationStatus !== "not_confirmed") {
      return validationStatus;
    }
    if (status === null || status === "pending") {
      return "not_confirmed";
    }
    return status;
  }, [record]);

export default useUserStatus;
